import config from "../../config";
import { GET_SERVICES, STOP_LOADER } from "./types";

export const GetServicesAction = () => async (dispatch, getState) => {
    try {
        let res = await config.getApi(
            config.services.getServices(),
            config.defaultHeaders
        );
        if (res) {
            dispatch({ type: GET_SERVICES, payload: res.response.data });
            dispatch({ type: STOP_LOADER });
        } else {
            console.log(res);
        }
    } catch (e) {
        console.log(e);
    }
};
